module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "figcenter1",
    attrs: {
      "id": "map1"
    }
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0044",
      "id": "id-701555607188239981",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    staticClass: "calibre6",
    attrs: {
      "alt": "",
      "id": "id-2163887914411563924",
      "src": "Images/img0094.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("MAP"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    staticClass: "smaller"
  }, [_vm._v("of the")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    staticClass: "larger"
  }, [_vm._v("NOVAYA ZEMLYA SEA")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    staticClass: "smaller"
  }, [_vm._v("for the")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nAustro-Hungarian"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nExpeditions.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00029",
      "title": "[1]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_1",
      "title": "[1]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0